export function File({ className }) {
  return (
    <div className={className}>
      <svg
        stroke="currentColor"
        fill="currentColor"
        stroke-width="0"
        viewBox="0 0 16 16"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5z"></path>
        <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5L9.5 0zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5z"></path>
      </svg>
    </div>
  );
}

export function Calendar({ className }) {
  return (
    <div className={className}>
      <svg
        stroke="currentColor"
        fill="currentColor"
        stroke-width="0"
        version="1.1"
        id="Layer_1"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.438,4.954H16.5c0-0.346,0-0.691,0-1.036c0-0.124,0-0.248,0-0.372c0-0.262-0.23-0.512-0.5-0.5
	c-0.271,0.012-0.5,0.22-0.5,0.5c0,0.469,0,0.939,0,1.408h-7c0-0.346,0-0.691,0-1.036c0-0.124,0-0.248,0-0.372
	c0-0.262-0.23-0.512-0.5-0.5c-0.271,0.012-0.5,0.22-0.5,0.5c0,0.469,0,0.939,0,1.408H5.562c-1.378,0-2.5,1.122-2.5,2.5v11
	c0,1.379,1.122,2.5,2.5,2.5h12.875c1.379,0,2.5-1.121,2.5-2.5v-11C20.938,6.076,19.816,4.954,18.438,4.954z M5.562,5.954H7.5
	c0,0.073,0,0.147,0,0.22c0,0.124,0,0.248,0,0.372c0,0.262,0.23,0.512,0.5,0.5c0.271-0.012,0.5-0.22,0.5-0.5c0-0.197,0-0.394,0-0.592
	h7c0,0.073,0,0.147,0,0.22c0,0.124,0,0.248,0,0.372c0,0.262,0.23,0.512,0.5,0.5c0.271-0.012,0.5-0.22,0.5-0.5
	c0-0.197,0-0.394,0-0.592h1.937c0.827,0,1.5,0.673,1.5,1.5v1.584H4.062V7.454C4.062,6.627,4.735,5.954,5.562,5.954z M18.438,19.954
	H5.562c-0.827,0-1.5-0.673-1.5-1.5v-8.416h15.875v8.416C19.938,19.281,19.265,19.954,18.438,19.954z"
        ></path>
      </svg>
    </div>
  );
}

export function Timer({ className }) {
  return (
    <div className={className}>
      <svg
        stroke="currentColor"
        fill="currentColor"
        stroke-width="0"
        viewBox="0 0 512 512"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M256 456c-110.3 0-200-89.7-200-200 0-54.8 21.7-105.9 61.2-144 6.4-6.2 16.6-6 22.7.4 6.2 6.4 6 16.6-.4 22.7-33.1 32-51.3 74.9-51.3 120.9 0 92.5 75.3 167.8 167.8 167.8S423.8 348.5 423.8 256c0-87.1-66.7-159-151.8-167.1v62.6c0 8.9-7.2 16.1-16.1 16.1s-16.1-7.2-16.1-16.1V72.1c0-8.9 7.2-16.1 16.1-16.1 110.3 0 200 89.7 200 200S366.3 456 256 456z"></path>
        <path d="M175.9 161.9l99.5 71.5c13.5 9.7 16.7 28.5 7 42s-28.5 16.7-42 7c-2.8-2-5.2-4.4-7-7l-71.5-99.5c-3.2-4.5-2.2-10.8 2.3-14 3.6-2.6 8.3-2.4 11.7 0z"></path>
      </svg>
    </div>
  );
}

export function MoreHorizontal({ className }) {
  return (
    <div className={className}>
      <svg
        stroke="currentColor"
        fill="none"
        stroke-width="2"
        viewBox="0 0 24 24"
        stroke-linecap="round"
        stroke-linejoin="round"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="1"></circle>
        <circle cx="19" cy="12" r="1"></circle>
        <circle cx="5" cy="12" r="1"></circle>
      </svg>
    </div>
  );
}

export function SendIcon({ className }) {
  return (
    <div className={className}>
      <svg
        stroke="currentColor"
        fill="currentColor"
        stroke-width="0"
        viewBox="0 0 512 512"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M435.9 64.9l-367.1 160c-6.5 3.1-6.3 12.4.3 15.3l99.3 56.1c5.9 3.3 13.2 2.6 18.3-1.8l195.8-168.8c1.3-1.1 4.4-3.2 5.6-2 1.3 1.3-.7 4.3-1.8 5.6L216.9 320.1c-4.7 5.3-5.4 13.1-1.6 19.1l64.9 104.1c3.2 6.3 12.3 6.2 15.2-.2L447.2 76c3.3-7.2-4.2-14.5-11.3-11.1z"></path>
      </svg>
    </div>
  );
}

export function SlArrowRight({ className }) {
  return (
    <div className={className}>
      <svg
        stroke="currentColor"
        fill="currentColor"
        stroke-width="0"
        viewBox="0 0 1024 1024"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M271.653 1023.192c-8.685 0-17.573-3.432-24.238-10.097-13.33-13.33-13.33-35.144 0-48.474L703.67 508.163 254.08 58.573c-13.33-13.331-13.33-35.145 0-48.475 13.33-13.33 35.143-13.33 48.473 0L776.38 483.925c13.33 13.33 13.33 35.143 0 48.473l-480.492 480.694c-6.665 6.665-15.551 10.099-24.236 10.099z"></path>
      </svg>
    </div>
  );
}

export function IoSettingsOutline({ className }) {
  return (
    <div className={className}>
      <svg
        stroke="currentColor"
        fill="currentColor"
        stroke-width="0"
        viewBox="0 0 512 512"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="32"
          d="M262.29 192.31a64 64 0 1057.4 57.4 64.13 64.13 0 00-57.4-57.4zM416.39 256a154.34 154.34 0 01-1.53 20.79l45.21 35.46a10.81 10.81 0 012.45 13.75l-42.77 74a10.81 10.81 0 01-13.14 4.59l-44.9-18.08a16.11 16.11 0 00-15.17 1.75A164.48 164.48 0 01325 400.8a15.94 15.94 0 00-8.82 12.14l-6.73 47.89a11.08 11.08 0 01-10.68 9.17h-85.54a11.11 11.11 0 01-10.69-8.87l-6.72-47.82a16.07 16.07 0 00-9-12.22 155.3 155.3 0 01-21.46-12.57 16 16 0 00-15.11-1.71l-44.89 18.07a10.81 10.81 0 01-13.14-4.58l-42.77-74a10.8 10.8 0 012.45-13.75l38.21-30a16.05 16.05 0 006-14.08c-.36-4.17-.58-8.33-.58-12.5s.21-8.27.58-12.35a16 16 0 00-6.07-13.94l-38.19-30A10.81 10.81 0 0149.48 186l42.77-74a10.81 10.81 0 0113.14-4.59l44.9 18.08a16.11 16.11 0 0015.17-1.75A164.48 164.48 0 01187 111.2a15.94 15.94 0 008.82-12.14l6.73-47.89A11.08 11.08 0 01213.23 42h85.54a11.11 11.11 0 0110.69 8.87l6.72 47.82a16.07 16.07 0 009 12.22 155.3 155.3 0 0121.46 12.57 16 16 0 0015.11 1.71l44.89-18.07a10.81 10.81 0 0113.14 4.58l42.77 74a10.8 10.8 0 01-2.45 13.75l-38.21 30a16.05 16.05 0 00-6.05 14.08c.33 4.14.55 8.3.55 12.47z"
        ></path>
      </svg>
    </div>
  );
}

export function IoOpenOutline({ className }) {
  return (
    <div className={className}>
      <svg
        stroke="currentColor"
        fill="currentColor"
        stroke-width="0"
        viewBox="0 0 512 512"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="32"
          d="M336 112a80 80 0 00-160 0v96"
        ></path>
        <rect
          width="320"
          height="272"
          x="96"
          y="208"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="32"
          rx="48"
          ry="48"
        ></rect>
      </svg>
    </div>
  );
}

export function AiOutlineLogout({ className }) {
  return (
    <div className={className}>
      <svg
        stroke="currentColor"
        fill="currentColor"
        stroke-width="0"
        viewBox="0 0 1024 1024"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M868 732h-70.3c-4.8 0-9.3 2.1-12.3 5.8-7 8.5-14.5 16.7-22.4 24.5a353.84 353.84 0 0 1-112.7 75.9A352.8 352.8 0 0 1 512.4 866c-47.9 0-94.3-9.4-137.9-27.8a353.84 353.84 0 0 1-112.7-75.9 353.28 353.28 0 0 1-76-112.5C167.3 606.2 158 559.9 158 512s9.4-94.2 27.8-137.8c17.8-42.1 43.4-80 76-112.5s70.5-58.1 112.7-75.9c43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 7.9 7.9 15.3 16.1 22.4 24.5 3 3.7 7.6 5.8 12.3 5.8H868c6.3 0 10.2-7 6.7-12.3C798 160.5 663.8 81.6 511.3 82 271.7 82.6 79.6 277.1 82 516.4 84.4 751.9 276.2 942 512.4 942c152.1 0 285.7-78.8 362.3-197.7 3.4-5.3-.4-12.3-6.7-12.3zm88.9-226.3L815 393.7c-5.3-4.2-13-.4-13 6.3v76H488c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 0 0 0-12.6z"></path>
      </svg>
    </div>
  );
}

export function BsBell({ className }) {
  return (
    <div className={className}>
      <svg
        stroke="currentColor"
        fill="currentColor"
        stroke-width="0"
        viewBox="0 0 16 16"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M8 16a2 2 0 0 0 2-2H6a2 2 0 0 0 2 2zM8 1.918l-.797.161A4.002 4.002 0 0 0 4 6c0 .628-.134 2.197-.459 3.742-.16.767-.376 1.566-.663 2.258h10.244c-.287-.692-.502-1.49-.663-2.258C12.134 8.197 12 6.628 12 6a4.002 4.002 0 0 0-3.203-3.92L8 1.917zM14.22 12c.223.447.481.801.78 1H1c.299-.199.557-.553.78-1C2.68 10.2 3 6.88 3 6c0-2.42 1.72-4.44 4.005-4.901a1 1 0 1 1 1.99 0A5.002 5.002 0 0 1 13 6c0 .88.32 4.2 1.22 6z"></path>
      </svg>
    </div>
  );
}

export function BsChevronLeft({ className }) {
  return (
    <div className={className}>
      <svg
        stroke="currentColor"
        fill="currentColor"
        stroke-width="0"
        viewBox="0 0 16 16"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
        ></path>
      </svg>
    </div>
  );
}

export function AmazonIcon({ className, color }) {
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 65 65"
        fill="none"
      >
        <circle
          cx="32.5"
          cy="32.5"
          r="32.5"
          fill={color ? `#${color}` : "#03C4DC"}
          fill-opacity="0.1"
        />
        <circle
          cx="32.5"
          cy="32.5"
          r="32"
          stroke={color ? `#${color}` : "#03C4DC"}
          stroke-opacity="0.3"
        />
        <path
          d="M19.0462 39.6437C19.1262 39.5144 19.2555 39.5144 19.434 39.6437C23.3958 41.9522 27.9048 43.1543 32.49 43.1247C35.671 43.104 38.8205 42.4935 41.7788 41.3242L42.1297 41.1857L42.4528 41.0379C42.5479 40.9862 42.6591 40.9726 42.7638 41.0001C42.8684 41.0275 42.9587 41.0939 43.0161 41.1857C43.1546 41.3703 43.1084 41.5458 42.8868 41.712C42.6652 41.8782 42.2312 42.1552 41.7788 42.4322C40.3359 43.2757 38.7819 43.9129 37.1621 44.325C34.0392 45.1726 30.7535 45.2228 27.6062 44.471C24.4589 43.7193 21.5505 42.1896 19.1477 40.0223C19.1056 39.9971 19.0702 39.9621 19.0444 39.9203C19.0187 39.8785 19.0035 39.8311 19 39.7822C19.0027 39.7327 19.0187 39.6849 19.0462 39.6437ZM26.2759 32.8017C26.2452 31.7953 26.5293 30.8044 27.0885 29.9671C27.6485 29.1725 28.4237 28.5542 29.3229 28.185C30.348 27.782 31.4225 27.518 32.5177 27.4002C32.9517 27.3448 33.6534 27.2802 34.6321 27.2063V26.8C34.6952 26.0838 34.5777 25.3632 34.2905 24.7041C34.1105 24.4594 33.871 24.2648 33.5946 24.1388C33.3183 24.0127 33.0143 23.9594 32.7116 23.9838H32.5177C32.0223 24.0159 31.5472 24.1925 31.1512 24.4917C30.7589 24.7827 30.4917 25.2117 30.4032 25.692C30.3937 25.8228 30.3416 25.9469 30.2549 26.0453C30.1682 26.1436 30.0517 26.2109 29.9231 26.2368L27.1531 25.9044C26.8853 25.8398 26.7468 25.692 26.7468 25.4704C26.7433 25.4151 26.7433 25.3596 26.7468 25.3042C26.8488 24.6674 27.0831 24.0591 27.4346 23.5184C27.786 22.9777 28.2469 22.5166 28.7874 22.1649C29.8965 21.464 31.1699 21.0661 32.4808 21.0107H33.1271C34.6802 20.9186 36.2097 21.424 37.4022 22.4234C37.5597 22.5871 37.7076 22.7598 37.8454 22.9405C37.9746 23.1251 38.0854 23.2913 38.1685 23.4391C38.2635 23.6362 38.3348 23.8438 38.3809 24.0577C38.4455 24.3347 38.4917 24.5194 38.5286 24.621C38.5715 24.8433 38.5962 25.0687 38.6025 25.295C38.6025 25.6366 38.6025 25.8398 38.6025 25.9044V31.7214C38.5992 32.1077 38.6617 32.4918 38.7872 32.8571C38.8687 33.12 38.9836 33.3713 39.1288 33.605C39.2488 33.7528 39.4243 34.0021 39.6828 34.3345C39.7711 34.4453 39.8227 34.5808 39.8306 34.7223C39.8274 34.7892 39.8082 34.8544 39.7744 34.9123C39.7406 34.9702 39.6934 35.019 39.6366 35.0547L37.476 36.9014C37.3756 36.9711 37.2582 37.0123 37.1362 37.0204C37.0142 37.0286 36.8923 37.0034 36.7835 36.9475C36.5762 36.7743 36.3789 36.5893 36.1926 36.3935L35.8325 36.015C35.7586 35.9319 35.6478 35.7749 35.4816 35.5441L35.1492 35.0732C34.457 35.9215 33.5428 36.5608 32.5085 36.9198C31.8487 37.0928 31.1682 37.1736 30.4863 37.1599C29.9294 37.1801 29.3739 37.0893 28.8524 36.8927C28.3309 36.6961 27.8537 36.3978 27.4486 36.015C27.0429 35.5886 26.7294 35.0833 26.5277 34.5305C26.3259 33.9776 26.2402 33.3892 26.2759 32.8017ZM30.4032 32.3216C30.3777 32.8603 30.5446 33.3905 30.8742 33.8174C31.0255 34.0021 31.2178 34.1492 31.4357 34.2469C31.6536 34.3446 31.8913 34.3904 32.1299 34.3807H32.333H32.5177C32.8569 34.2775 33.1697 34.1019 33.4344 33.866C33.699 33.63 33.9092 33.3393 34.0504 33.0141C34.2312 32.7259 34.3739 32.4155 34.4752 32.0908C34.547 31.803 34.5934 31.5095 34.6137 31.2136C34.6137 30.992 34.6137 30.6227 34.6137 30.1056V29.5054C33.9036 29.4831 33.1934 29.5482 32.4992 29.6993C31.8941 29.8137 31.35 30.1411 30.9655 30.6222C30.5809 31.1032 30.3815 31.7061 30.4032 32.3216ZM40.5138 40.05C40.5509 39.9769 40.6009 39.9112 40.6616 39.8561C41.0116 39.6122 41.398 39.4252 41.8065 39.3021C42.3882 39.1458 42.9864 39.059 43.5885 39.0435C43.7385 39.0201 43.8911 39.0201 44.041 39.0435C44.5019 39.0245 44.9572 39.1505 45.3429 39.4036C45.4143 39.5366 45.4463 39.6871 45.4352 39.8376V40.0038C45.4096 40.688 45.2562 41.3613 44.9828 41.989C44.7137 42.6985 44.2764 43.3322 43.7086 43.8357C43.6471 43.8903 43.5691 43.9227 43.487 43.928C43.4568 43.9362 43.4249 43.9362 43.3946 43.928C43.3023 43.8818 43.2746 43.7987 43.3208 43.6695C43.7877 42.7579 44.0998 41.7749 44.2441 40.7609C44.2578 40.6279 44.2252 40.4942 44.1518 40.3824C43.9948 40.1885 43.5424 40.0869 42.8037 40.0869C42.5359 40.0869 42.2128 40.0869 41.8804 40.1423L40.7816 40.2808C40.7351 40.2926 40.6864 40.2929 40.6397 40.2816C40.5931 40.2703 40.5498 40.2479 40.5138 40.2162C40.5057 40.2021 40.5014 40.1862 40.5014 40.17C40.5014 40.1538 40.5057 40.1379 40.5138 40.1238C40.5076 40.0996 40.5076 40.0742 40.5138 40.05Z"
          fill={color ? `#${color}` : "#03C4DC"}
        />
      </svg>
    </div>
  );
}

export function BankIcon({ className, color }) {
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 65 65"
        fill="none"
      >
        <circle
          cx="32.5"
          cy="32.5"
          r="32.5"
          fill={color ? `#${color}` : "#03C4DC"}
          fill-opacity="0.1"
        />
        <circle
          cx="32.5"
          cy="32.5"
          r="32"
          stroke={color ? `#${color}` : "#03C4DC"}
          stroke-opacity="0.3"
        />
        <path
          d="M45.3432 32.3284V28.3115L32.6716 21L20 28.3115V32.3284H22.5343V42.4657H20V45H45.3432V42.4657H42.8089V32.3284H45.3432ZM22.5343 29.7941L32.6716 23.9398L42.8089 29.7941H22.5343ZM25.0686 42.4657V32.3284H27.603V42.4657H25.0686ZM30.1373 42.4657V32.3284H35.2059V42.4657H30.1373ZM40.2746 42.4657H37.7402V32.3284H40.2746V42.4657Z"
          fill={color ? `#${color}` : "#03C4DC"}
        />
      </svg>
    </div>
  );
}

export function PaypalIcon({ className, color }) {
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 65 65"
        fill="none"
      >
        <circle
          cx="32.5"
          cy="32.5"
          r="32.5"
          fill={color ? `#${color}` : "#03C4DC"}
          fill-opacity="0.1"
        />
        <circle
          cx="32.5"
          cy="32.5"
          r="32"
          stroke={color ? `#${color}` : "#03C4DC"}
          stroke-opacity="0.3"
        />
        <path
          d="M35.2131 27.2986C35.3236 26.9957 35.3574 26.6702 35.3115 26.351C35.2657 26.0319 35.1416 25.729 34.9504 25.4694C34.7592 25.2098 34.5067 25.0016 34.2155 24.8631C33.9243 24.7247 33.6034 24.6605 33.2814 24.6761H30.4833L29.3125 29.9211H31.9935C32.7393 29.883 33.4535 29.6082 34.0324 29.1366C34.6114 28.6651 35.025 28.0212 35.2131 27.2986V27.2986Z"
          stroke={color ? `#${color}` : "#03C4DC"}
          stroke-width="2.7"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 40.903L25.6831 21H35.3887C38.3039 21 41.5469 23.0957 40.5752 27.5329C40.1961 29.366 39.1832 31.0069 37.7144 32.1674C36.2456 33.3279 34.4148 33.9337 32.5437 33.8784H28.4578L26.7133 40.903H21Z"
          stroke={color ? `#${color}` : "#03C4DC"}
          stroke-width="2.7"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M44.2631 27.6602C46.0192 30.7744 43.8182 37.8692 36.8287 37.9746H32.6023L30.8227 44.9992H25.1094L25.3904 43.5474"
          stroke={color ? `#${color}` : "#03C4DC"}
          stroke-width="2.7"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
}

export function CharityIcon({ className, color }) {
  return (
    <div className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        viewBox="0 0 65 65"
        fill="none"
      >
        <circle
          cx="32.5"
          cy="32.5"
          r="32.5"
          fill={color ? `#${color}` : "#03C4DC"}
          fill-opacity="0.1"
        />
        <circle
          cx="32.5"
          cy="32.5"
          r="32"
          stroke={color ? `#${color}` : "#03C4DC"}
          stroke-opacity="0.3"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.2352 37.1046C19.9635 36.7812 19.5249 36.6214 19.089 36.7231L15.8914 37.4694C15.5807 37.5419 15.3141 37.7399 15.1545 38.0163C14.995 38.2924 14.9571 38.6224 15.0496 38.9279L17.5507 47.1807C17.7271 47.7627 18.325 48.1078 18.9173 47.9696L22.1149 47.2233C22.4256 47.1507 22.6923 46.9528 22.8518 46.6767C22.9321 46.5374 22.9817 46.3848 22.9994 46.2283C25.0254 46.2206 28.7566 46.176 31.6388 45.9683C33.6326 45.8249 35.2528 45.5515 35.8407 45.2342C37.3142 44.4389 41.9928 41.1864 43.3583 39.2004C44.0265 38.2289 44.0135 37.358 43.6659 36.8025C43.2423 36.1257 42.7421 35.7259 42.167 35.5209C41.6239 35.3274 40.9867 35.3058 40.2116 35.5093C39.601 35.6696 38.8611 35.9981 37.9453 36.4711C37.7947 36.1742 37.5651 35.8892 37.242 35.6287C37.0332 35.4606 36.6388 35.2587 36.0806 35.1579C35.2102 35.0009 33.8001 35.0383 32.3169 35.7289C31.7185 36.0075 31.2123 35.8172 30.6704 35.601C30.0805 35.3659 29.4663 35.0704 28.7726 34.8619C27.1568 34.3762 25.1912 34.7602 23.4228 35.4678C22.1853 35.9632 21.0496 36.6004 20.2352 37.1046ZM18.5607 39.2162L18.5645 39.2283L20.3914 45.2561C20.3914 45.2558 19.4457 45.4768 19.4457 45.4768L17.6153 39.4369L18.5607 39.2162ZM32.1848 39.6645C33.2931 39.0539 35.2368 37.9495 35.2789 37.9268C35.4381 37.841 35.5763 37.7479 35.6884 37.6469C35.7391 37.6014 35.7945 37.5294 35.8305 37.4785C35.5627 37.4505 34.3011 37.3506 33.2909 37.8208C32.2095 38.3242 31.2619 38.2431 30.2957 37.9216C29.6142 37.6948 28.9211 37.3159 28.1083 37.072C26.9483 36.7233 25.5501 37.1022 24.2804 37.6103C22.9324 38.1497 21.7214 38.8792 21.0108 39.3444L22.3985 43.9221C24.1644 43.9213 28.3321 43.8931 31.4729 43.6668C33.0175 43.5555 34.2892 43.4494 34.7444 43.2035C35.9061 42.5766 39.2939 40.2743 40.9466 38.5092C41.1684 38.2721 41.5381 37.9216 41.3922 37.6945C41.2047 37.4034 40.673 37.7485 40.1178 37.9792C39.2186 38.3527 38.0838 38.9852 36.6128 39.8204C36.5364 39.8675 36.3481 39.9719 36.3345 39.9785C35.4472 40.4828 34.4417 41.0557 33.2981 41.6857C32.7866 41.9674 32.0583 42.087 31.2813 42.054C30.3702 42.0155 29.386 41.7893 28.8125 41.6259C28.2002 41.4515 27.8447 40.8126 28.0191 40.2001C28.1936 39.5875 28.8325 39.2322 29.445 39.4067C29.8944 39.5346 30.6648 39.7182 31.379 39.7484C31.6861 39.7614 31.9827 39.7758 32.1848 39.6645ZM41.6156 19.7717C39.5897 19.7794 35.8582 19.824 32.9763 20.0317C30.9822 20.1754 29.3619 20.4485 28.774 20.7658C27.3005 21.5614 22.622 24.8138 21.2565 26.7996C20.5883 27.7713 20.6013 28.642 20.9488 29.1975C21.3725 29.8743 21.8729 30.2741 22.4478 30.4791C22.9911 30.6729 23.628 30.6942 24.4031 30.4907C25.0137 30.3306 25.7537 30.0022 26.6694 29.5289C26.8201 29.8258 27.0496 30.111 27.3728 30.3713C27.5816 30.5397 27.9762 30.7413 28.5345 30.8421C29.4048 30.9994 30.8146 30.962 32.2981 30.2714C32.8963 29.9928 33.4027 30.183 33.9444 30.399C34.5342 30.6344 35.1484 30.9299 35.8424 31.1384C37.4582 31.6238 39.4235 31.24 41.1919 30.5322C42.4298 30.0368 43.5654 29.3999 44.3796 28.8954C44.6512 29.2188 45.0901 29.3789 45.5257 29.2769L48.7233 28.5307C49.034 28.4581 49.3007 28.2601 49.4602 27.984C49.6197 27.7076 49.6579 27.3776 49.5655 27.0724L47.064 18.8193C46.8876 18.2373 46.2898 17.8922 45.6974 18.0304L42.4998 18.7767C42.1891 18.8493 41.9225 19.0472 41.763 19.3236C41.6826 19.4626 41.6331 19.6155 41.6156 19.7717ZM42.2165 22.0779C40.4504 22.0787 36.2827 22.1072 33.1422 22.3335C31.5975 22.4448 30.3259 22.5506 29.8703 22.7965C28.7087 23.4237 25.3208 25.726 23.6682 27.4908C23.4464 27.7279 23.0767 28.0784 23.2229 28.3055C23.4101 28.5968 23.9418 28.2515 24.497 28.0208C25.3962 27.6476 26.531 27.0148 28.0022 26.1796C28.0784 26.1325 28.1576 26.0868 28.2398 26.0425C28.2531 26.0353 28.2667 26.0284 28.2803 26.0218C29.1675 25.5172 30.173 24.9443 31.3167 24.3143C31.8282 24.0326 32.5565 23.913 33.3335 23.946C34.2446 23.9847 35.229 24.2107 35.8023 24.3741C36.4148 24.5485 36.7704 25.1877 36.5956 25.7999C36.4212 26.4125 35.7823 26.7681 35.1698 26.5936C34.7203 26.4654 33.9499 26.2818 33.2358 26.2516C32.9289 26.2386 32.6323 26.2245 32.4302 26.3358C31.3217 26.9461 30.3359 27.5033 29.4558 27.9987C29.4179 28.0255 29.378 28.0505 29.3362 28.0732C29.1767 28.1593 29.0385 28.2523 28.9263 28.3531C28.8759 28.3986 28.8203 28.4708 28.7843 28.5215C29.0523 28.5498 30.3137 28.6497 31.3239 28.1792C32.4053 27.6758 33.3529 27.7569 34.3191 28.0784C35.0006 28.3055 35.694 28.6841 36.5065 28.9283C37.6668 29.2769 39.0649 28.8978 40.3346 28.3897C41.6824 27.8503 42.8933 27.1209 43.6039 26.6559L42.2165 22.0779ZM46.0544 26.7838L46.0505 26.7717L44.2237 20.7442L45.1691 20.5235L46.9998 26.5631L46.0544 26.7838Z"
          fill={color ? `#${color}` : "#03C4DC"}
        />
      </svg>
    </div>
  );
}

export function RxHamburgerMenu({ className }) {
  return (
    <div className={className}>
      <svg
        stroke="currentColor"
        fill="currentColor"
        stroke-width="0"
        viewBox="0 0 512 512"
        height="1em"
        width="1em"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M32 96v64h448V96H32zm0 128v64h448v-64H32zm0 128v64h448v-64H32z"></path>
      </svg>
    </div>
  );
}
